import { buildImageUrl } from "@/sanity/lib/image"
import { transformSanityToBunnyCdn } from "@/lib/sanityLoader"
import { type ImageType } from "@/types"

export function getVideoPosterUrl(poster: ImageType | null | undefined): string {
    if (!poster?.asset) {
        return ""
    }

    try {
        return transformSanityToBunnyCdn(
            buildImageUrl(poster.asset)
                .width(poster.asset.width ?? 1920)
                .auto("format")
                .quality(80)
                .fit("clip")
                .url()
        )
    } catch {
        return poster.asset.url ?? ""
    }
}

export function getVideoObjectThumbnailUrl(poster: ImageType | null | undefined): string {
    return getVideoPosterUrl(poster) || poster?.asset?.url || ""
}
